import { render } from "./PopupAnnouncementMessage.vue?vue&type=template&id=56a0f96a&scoped=true"
import script from "./PopupAnnouncementMessage.vue?vue&type=script&lang=js"
export * from "./PopupAnnouncementMessage.vue?vue&type=script&lang=js"

import "./PopupAnnouncementMessage.vue?vue&type=style&index=0&id=56a0f96a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a0f96a"]])

export default __exports__